import React, { useEffect, useState } from 'react'
import { Modal, Button, Input, InputNumber, Tooltip } from 'antd'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'

/** A, B, … Z, AA, AB… */
const letraDesdeIndice = (indice) => {
  let n = indice
  let s = ''
  do {
    s = String.fromCharCode(65 + (n % 26)) + s
    n = Math.floor(n / 26) - 1
  } while (n >= 0)
  return s
}

const filaVacia = (indice) => ({
  key: `m-${Date.now()}-${indice}`,
  texto: '',
  valor: null,
})

/**
 * Modal para definir medidas a mano cuando la revisión no tiene plantilla.
 * Cada fila: letra automática, texto (descripción) y valor en mm.
 */
const ModalMedidasManualesCotizacion = ({ open, onCancel, onContinuar }) => {
  const [filas, setFilas] = useState([filaVacia(0)])

  useEffect(() => {
    if (open) setFilas([filaVacia(0)])
  }, [open])

  const actualizar = (key, cambios) => {
    setFilas((prev) => prev.map((f) => (f.key === key ? { ...f, ...cambios } : f)))
  }

  const eliminar = (key) => {
    setFilas((prev) => (prev.length <= 1 ? prev : prev.filter((f) => f.key !== key)))
  }

  const agregar = () => {
    setFilas((prev) => [...prev, filaVacia(prev.length)])
  }

  const handleContinuar = () => {
    const validas = filas
      .map((f, i) => ({
        medida: letraDesdeIndice(i),
        definicion_cotas: String(f.texto || '').trim(),
        descripcion: String(f.texto || '').trim(),
        valor: f.valor === null || f.valor === undefined || f.valor === '' ? '' : String(f.valor),
        tipo_campo: 'Num',
      }))
      .filter((e) => e.definicion_cotas)
    if (!validas.length) return
    onContinuar?.(validas)
  }

  const puedeContinuar = filas.some((f) => String(f.texto || '').trim())

  return (
    <Modal
      open={open}
      title="Agregar medidas manualmente"
      onCancel={onCancel}
      destroyOnClose
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="ok" type="primary" disabled={!puedeContinuar} onClick={handleContinuar}>
          Continuar
        </Button>,
      ]}
    >
      <p style={{ marginBottom: 12, color: '#595959' }}>
        Define las medidas que aparecerán en la imagen de cotización. La letra se asigna sola.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {filas.map((f, i) => (
          <div
            key={f.key}
            style={{ display: 'grid', gridTemplateColumns: '36px 1fr 100px 32px', gap: 8, alignItems: 'center' }}
          >
            <span
              style={{
                fontWeight: 700,
                color: '#d42a20',
                textAlign: 'center',
                fontSize: 16,
              }}
            >
              {letraDesdeIndice(i)}
            </span>
            <Input
              placeholder="Texto / descripción"
              value={f.texto}
              onChange={(e) => actualizar(f.key, { texto: e.target.value })}
            />
            <InputNumber
              placeholder="mm"
              style={{ width: '100%' }}
              value={f.valor}
              onChange={(v) => actualizar(f.key, { valor: v })}
            />
            <Tooltip title="Quitar fila">
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                disabled={filas.length <= 1}
                onClick={() => eliminar(f.key)}
              />
            </Tooltip>
          </div>
        ))}
      </div>
      <Button type="dashed" icon={<PlusOutlined />} onClick={agregar} style={{ marginTop: 12, width: '100%' }}>
        Agregar medida
      </Button>
    </Modal>
  )
}

export default ModalMedidasManualesCotizacion
